<template>
  <transition name="popup-fade" appear>
    <div
      v-if="!isHidden && popupVisible"
      class="popup"
      :style="{ top, right }"
      ref="popupRoot"
    >
     <NotificationV2NotificationPage 
      :popup="true"
      />
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import { onClickOutside } from '@vueuse/core'
import UiButton from '~/components/ui/Button.vue'
import NotificationTabs from './NotificationTabs.vue'
import NotificationList from './NotificationList.vue'
import { usePopupPosition } from './usePopupPosition'
import { NotificationChannel } from '~/types/notification'

const router = useRouter()

const { top, right, isHidden } = usePopupPosition()
const { 
  popupVisible, 
  tabCounts,
  loadNotificationGroups,
  initializeNotifications
} = useNotifications()
const route = useRoute()

const activeTab = ref<NotificationChannel>(NotificationChannel.Direct)
const listRefDirect = ref<any>(null)
const listRefFollowing = ref<any>(null)
const listRefCommunity = ref<any>(null)
const isInitialized = ref(false)

const switchTab = (newTab: NotificationChannel) => {
  activeTab.value = newTab
}

const onListInitialized = () => {
  isInitialized.value = true
}

const markAllAsRead = () => {
  useNotifications().markAllAsRead()
  listRefDirect.value.markAllAsReadAndClear()
  listRefFollowing.value.markAllAsReadAndClear()
  listRefCommunity.value.markAllAsReadAndClear()
}

// Initialize notifications when popup is first opened
onMounted(async () => {
  if (!isInitialized.value) {
    // await initializeNotifications()
    // isInitialized.value = true
  }
})

// Close popup when clicking outside
const popupRoot = ref(null)
onClickOutside(popupRoot, () => {
  popupVisible.value = false
})

watch(router.currentRoute, (newCurrentRoute, oldCurrentRoute) => {

  if(oldCurrentRoute.fullPath === newCurrentRoute.fullPath)
    return

  if (popupVisible.value) {
    popupVisible.value = false
  }
}, {deep: true})

</script>




<style scoped>
.popup{
  position:fixed;
  width:720px;
  height:480px;
  background-color:var(--un-background-color);
  border-radius:8px;
  display:flex;
  flex-direction:column;
  z-index:1000;
  box-shadow:0 8px 16px rgba(0,0,0,.3);
  
}
.hd{ display:flex; align-items:center; justify-content:space-between; padding:5px 16px; }
.ttl{ font-size:16px; font-weight:600; color:var(--text-primary); }
.actions{ display:flex; gap:8px; }
.actions :deep(i){ color:var(--text-primary); font-size:16px; }

.popup-fade-enter-active,
.popup-fade-leave-active{ transition:opacity 150ms ease,transform 150ms ease; }
.popup-fade-enter-from,
.popup-fade-leave-to{ opacity:0; transform:scale(.95); }


.popup :deep(.tbs_menu){
  box-shadow: inset 0 -2px 0 0 #dadada;
}

</style>

